'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Groups = require('./Groups');

var _Groups2 = _interopRequireDefault(_Groups);

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FormControlLabel = require('material-ui/Form/FormControlLabel');

var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _MetamaskAccount = require('./MetamaskAccount');

var _MetamaskAccount2 = _interopRequireDefault(_MetamaskAccount);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserPageView = function (_EditableView) {
  _inherits(UserPageView, _EditableView);

  function UserPageView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserPageView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserPageView.__proto__ || Object.getPrototypeOf(UserPageView)).call.apply(_ref, [this].concat(args))), _this), _this.onUpdateAvatar = function (file) {
      if (file) {
        var id = file.id,
            path = file.path,
            mimetype = file.mimetype;

        if (!path) {
          _this.addError("File URL is empty");

          return;
        }

        if (!mimetype) {
          _this.addError("Wrong file type");
        } else if (!mimetype.match(/image/)) {
          _this.addError("Only images allow");
        } else {
          var image = path;

          _this.updateObject({
            image: image
          });
        }
      } else {
        _this.addError("File did not received");
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserPageView, [{
    key: 'setPageMeta',
    value: function setPageMeta(meta) {
      var setPageMeta = this.context.setPageMeta;
      setPageMeta && setPageMeta(meta || {
        title: this.getTitle()
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setPageMeta();
      _get(UserPageView.prototype.__proto__ || Object.getPrototypeOf(UserPageView.prototype), 'componentWillMount', this) && _get(UserPageView.prototype.__proto__ || Object.getPrototypeOf(UserPageView.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setPageMeta();
      _get(UserPageView.prototype.__proto__ || Object.getPrototypeOf(UserPageView.prototype), 'componentDidUpdate', this) && _get(UserPageView.prototype.__proto__ || Object.getPrototypeOf(UserPageView.prototype), 'componentDidUpdate', this).call(this);
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var draftObject = this.getObjectWithMutations();

      var _ref2 = draftObject || {},
          username = _ref2.username,
          fullname = _ref2.fullname;

      return fullname || username;
    }
  }, {
    key: 'renderAvatar',
    value: function renderAvatar() {
      var draftObject = this.getObjectWithMutations();
      return _react2.default.createElement(_Avatar2.default, {
        user: draftObject,
        updateUser: this.onUpdateAvatar,
        editable: this.canEdit()
      });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var currentUser = this.context.user;
      var data = this.props.data;

      var _ref3 = data || {},
          user = _ref3.object;

      return currentUser && user && (currentUser.id === user.id || currentUser.sudo === true) ? true : false;
    }
  }, {
    key: 'save',
    value: function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(UserPageView.prototype.__proto__ || Object.getPrototypeOf(UserPageView.prototype), 'save', this).call(this).then(function (r) {
                  var loadApiData = _this2.context.loadApiData;
                  loadApiData();
                  return r;
                }).catch(function (e) {
                  console.error(e);
                });

              case 2:
                result = _context.sent;
                return _context.abrupt('return', result);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _ref4.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: 'renderDefaultView',
    // render(){
    //   return null;
    // }
    value: function renderDefaultView() {
      var object = this.getObjectWithMutations();
      var inEditMode = this.isInEditMode();

      if (!object) {
        return null;
      }

      var userId = object.id,
          username = object.username,
          fullname = object.fullname;
      var currentUser = this.context.user;

      var _ref5 = currentUser || {},
          currentUserId = _ref5.id;

      return _react2.default.createElement(_Grid2.default, {
        container: true
      }, _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.renderAvatar()), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4
      }, currentUserId && currentUserId === userId ? _react2.default.createElement(_MetamaskAccount2.default, {
        where: {
          UserAuthed: {
            id: currentUserId
          }
        }
      }) : null, _react2.default.createElement(_Groups2.default, {
        user: object,
        inEditMode: inEditMode
      })));
    }
  }, {
    key: 'renderEditableView',
    value: function renderEditableView() {
      var _this3 = this;

      var _context2 = this.context,
          currentUser = _context2.user,
          PhoneField = _context2.PhoneField;
      var object = this.getObjectWithMutations();
      var inEditMode = this.isInEditMode();

      if (!object) {
        return null;
      }

      var hidden = object.hidden;
      return _react2.default.createElement(_Grid2.default, {
        container: true
      }, _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.renderAvatar(), _react2.default.createElement('input', {
        name: 'username',
        style: {
          border: "none",
          height: 0,
          width: 0,
          background: "transparent"
        }
      }), _react2.default.createElement('input', {
        name: 'password',
        type: 'password',
        style: {
          border: "none",
          height: 0,
          width: 0,
          background: "transparent"
        }
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4
      }, _react2.default.createElement(_Grid2.default, {
        container: true,
        spacing: 16
      }, _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.getTextField({
        name: "fullname",
        label: "Fullname",
        helperText: "Type fullname"
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.getTextField({
        name: "username",
        label: "Username",
        helperText: "Type username"
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.getTextField({
        name: "email",
        label: "Email",
        helperText: "Type email"
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.getTextField({
        Editor: PhoneField,
        name: "phone",
        label: "Phone",
        helperText: "Type phone"
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, this.getTextField({
        name: "password",
        label: "Password",
        type: "password",
        helperText: "Type password"
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_FormControlLabel2.default, {
        control: _react2.default.createElement(_Checkbox2.default, {
          checked: hidden ? true : false,
          onChange: function onChange(event, checked) {
            _this3.updateObject({
              hidden: checked
            });
          }
        }),
        label: 'Hide profile'
      }), _react2.default.createElement(_Typography2.default, {
        variant: 'caption'
      }, 'If checked, profile will be exclude from lists.')))), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4
      }, _react2.default.createElement(_Groups2.default, {
        user: object,
        inEditMode: inEditMode && currentUser && currentUser.sudo ? true : false
      })));
    }
  }]);

  return UserPageView;
}(_Editable2.default);

exports.default = UserPageView;
module.exports = exports['default'];